const Reflux = require("reflux");
const biAPI = require("app/util/api/bi-api");
const agendorAPI = require("app/util/api/agendor-api");
const dateToParam = require("./util/date-to-param").dateToParam;

const FunnelMovesActions = Reflux.createActions({
  "loadFunnels": { children: ["completed", "failed"] },
  "fetchData": { children: ["completed", "failed"] },
  "setOriginFunnelId": { },
  "setDestinationFunnelId": { },
  "recalculateFunnels": { },
});

FunnelMovesActions.loadFunnels.listen(function(){
  agendorAPI.get("/funnels", null, function(funnels) {
    this.completed(funnels);
  }.bind(this));
});

FunnelMovesActions.fetchData.listen(function(period, users, originFunnel, destinationFunnel) {
  let params = {
    start_date: dateToParam(period.startDate),
    end_date: dateToParam(period.endDate),
    users: users,
    origin_funnel: originFunnel,
    destination_funnel: destinationFunnel
  };

  biAPI.fetch("/funnel_moves", params, this.completed, this.failed);
});

module.exports = FunnelMovesActions;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/actions/funnel-moves-actions.js